import type { FC } from 'react';
import './styles.css';
import { ScrollColumnView } from '@ipfabric/ui-components/ScrollView/ScrollColumnView';
import { prop } from '@ipfabric/utils/fp/prop';
import { SecuritySchemaTree } from 'components/SecuritySchema/SecuritySchemaTree';
import { makeScrollbarsViewRef } from 'components/SecuritySchema/helpers/makeScrollbarsViewRef';
import { useSecuritySchemaContextSelectors } from 'components/SecuritySchema/model/SecuritySchemaModel';
import { useLocale } from 'containers/App/LocaleContext';
import { selectActiveReferencedTestSchemaRoot } from './model/selectors/selectActiveReferencedTestSchemaRoot';
import { selectSecuritySchemaTreeContext } from './model/selectors/selectSecuritySchemaTreeContext';

export const ReferencedTestDetail: FC = () => {
  const msg = useLocale();

  const ctxProps = useSecuritySchemaContextSelectors({
    referencedTestSchemaRoot: selectActiveReferencedTestSchemaRoot,
    securitySchemaTreeContext: selectSecuritySchemaTreeContext,
    treeScrollContainerRef: prop('treeScrollContainerRef'),
  });

  return (
    <div className='mt-lgu-10 flex flex-1 flex-col'>
      {ctxProps.referencedTestSchemaRoot === null ? (
        <p className='text-danger mt-lgu-10 text-center'>
          {msg.securitySchema.referencedTestNotFound}
        </p>
      ) : (
        <ScrollColumnView
          ref={makeScrollbarsViewRef(ctxProps.treeScrollContainerRef)}
        >
          <SecuritySchemaTree
            context={ctxProps.securitySchemaTreeContext}
            rootNodes={[ctxProps.referencedTestSchemaRoot]}
          />
        </ScrollColumnView>
      )}
    </div>
  );
};
